/* eslint-disable max-len */
import React from 'react'
import {useState} from 'react'
import GlobalContext from '../../../../components/Context/GloablContext'
import ErrorMessage from '../../../../components/ErrorMessage'
import Loader from '../../../../components/Loader'
import {useContext,useEffect} from 'react'
import OtpInputField from '../../../../components/OtpInput/index'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { verifyOtp } from '../../authSlice'
import { logIn ,setUserType} from '../../authSlice'
import { userService } from '../../../../services/user.services'
import refreshIdToken from '../../../../CommonMethods/RefreshIdFunction'
import MaskedEmail from '../../../../CommonMethods/MaskedEmail'
import authenticateUser from '../../../../config/aws-export'
import { dataService } from '../../../../services/data.services'
import { deleteWholeDatabase } from '../../../../components/HelpGuideModal/indexdb'
import { persistAuthSession, broadcastLogin } from '../../../../CommonMethods/authSession'
import { getClientIP, storeIPAddress } from '../../../../services/ipAddress.service'


export default function OtpPage({handleLogin,duration,userData,selectedPreference,loginCredentials,setDisplayOtpScreen,setOtp,otp,setIsTrustMyBrowser,displayOtpScreen,
    handelClear,setIsForgotPassword,setPreferenceModel,preferenceModel,setIsLoginPage,setloginCredentials,setSelectedPreference,loginData}) {
    const dispactch=useDispatch()
    const navigate=useNavigate()
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage ,setIsSideBar,WebSocketConnection,fetchAndCacheHelpGuides} = useContext(GlobalContext)
    const [loading, setloading] = useState(false);
    const [myInfo, setmyInfo] = useState({})
    const {email,password}=loginCredentials

    const [error, seterror] = useState(false);
    const [errorMsg,setErrorMsg]=useState("")
    // const [otp, setOtp] = useState(Array(6).fill(""));
    const [timer, setTimer] = useState(parseInt(duration));
    const [loginError, setloginError] = useState('')




    const handleRefreshToken = async () => {
        if(localStorage.getItem('IdToken')){
            refreshIdToken()
        }
        
    };
    
    useEffect(() => {
        let intervalId;

        if (timer > 0) {
            intervalId = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [timer]);

    // useEffect(()=>{
    //     setToastmessage("OTP has been sent successfully")
    // },[])

    const handleResendOTP = async () => {
        // Handle resend OTP logic here
        // Reset the timer to 30 seconds
        setErrorMsg('')
        seterror(false);
        const preference_id = sessionStorage.getItem('preference_id');
        const response = await userService.resendOtp(preference_id)
        if(response.error === false) {
            setPreferenceModel(false)
            setToastmessage(response.data.message)
            setTimer(parseInt(response.data.otp_resend_duration))
        } else{
            setPreferenceModel(false)
            setToastErrorMessage('Something went wrong !!!')
        }
        // setToastmessage("OTP resent successfully")
        // setTimer(parseInt(duration));
    };

    const handleBacktoLogin = (e) => {
        setErrorMsg('')
        seterror(false);
        setSelectedPreference([])
        // setloginCredentials({
        //     email: '',
        //     password: ''
        // });
        e.preventDefault();
        setDisplayOtpScreen(false)
        setIsForgotPassword(false)
        setIsLoginPage(true)
        // navigate('/')
    }

    const handleOTPVerification = async (e) => {
        
        e.preventDefault();
        setloading(true)
        deleteWholeDatabase()
        const val = otp.toString().replace(/,/g, '')
        if (val.split('').length >= 6) {
            try {
                
                const response = await userService.verifyLoginOtp(otp.join(''))

                if (response.error) {
                    setErrorMsg(response.message.response.data.message)
                    seterror(true);
                    if(response.message.response.data.message === "Maximum login attempts reached"){

                        setToastErrorMessage("Maximum login attempts reached")
                        handleBacktoLogin(e)
                    }
                    setloading(false)
                    

                } else {
                    
                    localStorage.setItem('LogoutfromAllTabs','false')
                    persistAuthSession({
                        AccessToken: response.data.AccessToken,
                        RefreshToken: response.data.RefreshToken,
                        IdToken: response.data.IdToken,
                        user_type: response.data.user_type,
                        currentTimestamp: ((new Date).getTime().toString()),
                        user_id: response.data.user_id,
                        id: response.data.id,
                        browser_trust_duration: response.data.browser_trust_duration,
                    });
                    const myInfo = {
                        first_name: response.data.first_name,
                        middle_name: response.data.last_name,
                        role: response.data.user_type
                    }
                    if (loginData?.data?.isLoggedIn === true) {
                        const DuplicateTabCloseRes = await userService.DuplicateTabClose('')
                    }
                        
                    WebSocketConnection()
                    fetchAndCacheHelpGuides()
                    persistAuthSession({
                        'user-info': JSON.stringify(myInfo),
                    });
                    broadcastLogin();
                    // Capture and store IP address
                    getClientIP().then(ip => {
                        if (ip) {
                            storeIPAddress(ip);
                        }
                    });
                    if (response?.data?.status === "reset-password") {
                        persistAuthSession({
                            'custom:is_first_time_login': "true",
                            email: email,
                        });
                        setToastmessage('Login successful')
                        refreshIdToken()
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        navigate('/reset-password',{ state: {'refresh_interval':intervalId} })
                        return
                        // location('/reset-password')

                    }else if(response.error === false && (response.data.redirect_to_trust_my_browser === true || response.data.redirect_to_trust_my_browser === 'true')) {
                        setDisplayOtpScreen(false)
                        setIsSideBar(false)
                        persistAuthSession({
                            'custom:is_first_time_login': "false",
                        });
                        authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''),password)
                        setIsTrustMyBrowser(true)
                    } else {
                        // const currentSession = await getUserRoles()
                        persistAuthSession({
                            'custom:is_first_time_login': "false",
                            email: email,
                        });
                        
                        if (response.data.user_type === 'admin-user'|| response.data.user_type==='corporate-user') {
        
                            dispactch(setUserType( response.data.user_type));
                            dispactch(verifyOtp(email));
                            dispactch(logIn())
                            broadcastLogin();
                            // Capture and store IP address
                            getClientIP().then(ip => {
                                if (ip) {
                                    storeIPAddress(ip);
                                }
                            });
                            authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''), password)
                            setIsSideBar(false)
                            //sessionStorage.setItem('user-info', JSON.stringify(myInfo));
                            setToastmessage('Login successful')

                            refreshIdToken()
                            const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                            navigate('/profile')
                            
                        } else {
                            
                            
                            // dispactch(handleGroup(newdata.idToken.payload['cognito:groups'] ||[]))
                            dispactch(setUserType( response.data.user_type))
                        }


                    }
                    setloading(false)
                }

                // OTP verification successful, redirect or perform any other actions
            } catch (error) {
                let errormsg=""
                if(error.code==="NotAuthorizedException"){
                    setErrorMsg(error.message)
                    errormsg=error.message
                }else{
                    setErrorMsg(error.message.split("error")[1])
                    errormsg=error.message.split("error")[1]
                }
                seterror(true);
                setloading(false)
                if(errormsg==="Invalid session for the user."){
                    setTimeout(()=>{
                        setDisplayOtpScreen(false)
                    },5000)
                }
               

            }
        } else {
            seterror(true);
            setloading(false)
            return

        }
    };
    return (
        <div className='w-[35%] 2xl:w-[30%]' >
            <div className='w-[280px] xl:[290px] 2xl:w-[320px] flex flex-col justify-center items-center h-screen'>
                <div className='w-full'>
                    <img src="/images/Arcm_login_logo.png" alt="Banner-Img" className='w-[233px] h-fit mx-auto' loading='lazy' decoding='async' />
                    <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>OTP Verification</h1>
                    <h1 className='text-lg font-normal text-[#777C88] text-center'>Enter the 6-digit OTP sent to </h1>
                    <h1 className='text-lg font-normal pb-[10px] text-[#777C88] text-center' > 
                        <h1 className='text-lg font-normal pb-[10px] text-[#777C88] text-center'>
                            {selectedPreference.otp_preference_mode === 'email' ? (
                                <MaskedEmail value={selectedPreference.preference} />
                            ) : (
                                `${selectedPreference?.country_code} ${selectedPreference?.preference?.slice(0, 2) + 
                                    '*'.repeat(selectedPreference?.preference?.length - 4) + 
                                    selectedPreference?.preference?.slice(-2)}`
                            )}
                        </h1>
                    </h1>
                    <form onSubmit={(e)=>handleOTPVerification(e)}>
                        <div className="digit-group flex justify-center pt-1.5">
                            
                            <OtpInputField
                                onChange={setOtp}
                                inputs={otp}
                                setInputs={setOtp}
                                value={otp}
                                inputType="tel"
                                shouldAutoFocus	
                                inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                numInputs={6}
                                error={error}
                                seterror={seterror}
                                renderInput={(props) => <input {...props} />}
                                separator={<span></span>}
                            />
                        </div>
                        {/* errormessage */}
                        {error &&<ErrorMessage error={error} message={errorMsg} classKey="text-xs font-normal text-[#C81720] mt-3 text-center" />}
                        {/* <p className='text-xs font-normal text-[#C81720] mt-3 text-center'>You entered an invalid OTP. Please try again</p> */}
                        <p className='mt-3 text-center text-xs font-normal text-[#777C88]'>Didn’t receive OTP?</p>
                        <div className='w-fit mx-auto'>
                            {timer===0?<><button 
                                onClick={(e)=>{
                                    //handleLogin(e,'resend');
                                    setOtp(Array(6).fill(""))
                                    handleResendOTP()
                                }}
                                disabled={timer>0||loading}
                                type="button"
                                className={`text-xs font-semibold text-[#008586] `}>
                                Resend OTP</button></>:<><span className={`text-xs font-semibold ${timer>0?'text-[#777C88]':'text-[#008586]'}`}>Resend OTP in </span><span className={`text-xs font-semibold ${'text-[#008586]'}`}>{timer.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}s</span></>
                            }
                         
                        </div>
                        <button type='submit'
                            id="otp-form"
                            disabled={otp.includes("")||loading||errorMsg==="Invalid session for the user."}
                            className='w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                            {!loading?' Verify OTP':<span>{<Loader/>}</span>}
                        </button>
                        <div className='flex justify-center w-full mt-6'>
                            <button disabled={loading} onClick={(e)=>{handleBacktoLogin(e)}} className='flex items-center'>
                                <span className='text-lg font-normal text-[#008586] ml-3'>Back to Login</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
